import React from 'react'
import AppProvider from 'store/provider'
import wrapPageElementHelper from 'helpers/wrapPageElement'

// React Context in Browser
// eslint-disable-next-line react/prop-types
export const wrapRootElement = ({ element }) => {
  return <AppProvider>{element}</AppProvider>
}

// Page Layout
export const wrapPageElement = wrapPageElementHelper
